__turbopack_context__.v({
  "label": "_35rqVa_label",
  "option": "_35rqVa_option",
  "option--loading": "_35rqVa_option--loading",
  "options": "_35rqVa_options",
  "shimmer": "_35rqVa_shimmer",
  "text-bar-sweep": "_35rqVa_text-bar-sweep",
});
